import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';
import { HealthData } from '../../Enums/HealthData.enum';
import { HealthDataType } from '../../Enums/HealthDataType.enum';

export const diabetesHealthDataFilterScheme: ItemScheme[] = [
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'component.chart.filter.viewInterval',
	},
	{
		type: MagicField.RADIOLIST,
		key: 'view',
		children: [
			{
				value: 'day',
				title: 'component.chart.filter.day',
			},
			{
				value: 'week',
				title: 'component.chart.filter.week',
			},
			{
				value: 'month',
				title: 'component.chart.filter.month',
			},
			{
				value: 'year',
				title: 'component.chart.filter.year',
			},
			{
				value: 'custom',
				title: 'component.chart.filter.custom',
			},
		],
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.CONDITION,
		value: 'view',
		settings: {
			rules: [
				{
					formControlKey: 'view',
					rule: 'equal',
					value: 'day',
				},
			],
		},
		children: [
			{
				type: MagicField.DATEPICKER,
				key: 'date',
				title: 'component.chart.filter.date',
				settings: {
					required: true,
				},
			},
		],
	},
	{
		type: MagicField.CONDITION,
		value: 'view',
		settings: {
			rules: [
				{
					formControlKey: 'view',
					rule: 'equal',
					value: 'day',
				},
			],
		},
		children: [
			{
				type: MagicField.RADIOLIST,
				key: 'dataType',
				children: [
					{
						value: HealthDataType.DEFAULT,
						title: 'component.chart.filter.averageValues',
					},
					{
						value: HealthDataType.RAW,
						title: 'component.chart.filter.allValues',
					},
				],
				settings: {
					required: true,
				},
			},
		],
	},
	{
		type: MagicField.CONDITION,
		value: 'view',
		settings: {
			rules: [
				{
					formControlKey: 'view',
					rule: 'equal',
					value: 'custom',
				},
			],
		},
		children: [
			{
				type: MagicField.TEXT,
				subType: 'filterLabel',
				title: 'component.chart.filter.period',
			},
			{
				type: MagicField.DATEPICKER,
				key: 'from',
				title: 'component.chart.filter.dateFrom',
				settings: {
					required: true,
				},
			},
			{
				type: MagicField.DATEPICKER,
				key: 'to',
				title: 'component.chart.filter.dateTo',
				settings: {
					required: true,
				},
			},
		],
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'component.chart.filter.chartsAndTables',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleBloodGlucose',
		title: 'component.chart.filter.glycemia',
	},
	{
		type: MagicField.CONDITION,
		subtype: 'view',
		value: 'toggleBloodGlucose',
		settings: {
			equal: true,
		},
		children: [
			{
				type: MagicField.CONTAINER,
				settings: {
					showLine: true,
				},
				children: [
					{
						type: MagicField.RADIOLIST,
						key: 'glucoseView',
						children: [
							{
								value: 'allValues',
								title: 'component.chart.filter.everything',
							},
							{
								value: 'individualValues',
								title: 'component.chart.filter.individual',
							},
						],
						settings: {
							required: true,
						},
					},
					{
						type: MagicField.CONDITION,
						subtype: 'view',
						value: 'glucoseView',
						settings: {
							equal: 'individualValues',
						},
						children: [
							{
								type: MagicField.CONTAINER,
								key: 'blood_glucose',
								children: [
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_EXTRA,
										title: 'component.healthData.category.glycemia.extra',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_FASTING,
										title: 'component.healthData.category.glycemia.fasting',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_BEFORE_BREAKFAST,
										title:
											'component.healthData.category.glycemia.beforeBreakfast',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_BEFORE_LUNCH,
										title: 'component.healthData.category.glycemia.beforeLunch',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_BEFORE_DINNER,
										title:
											'component.healthData.category.glycemia.beforeDinner',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_AFTER_BREAKFAST,
										title:
											'component.healthData.category.glycemia.2HoursAfterBreakfast',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_AFTER_LUNCH,
										title:
											'component.healthData.category.glycemia.2HoursAfterLunch',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_AFTER_DINNER,
										title:
											'component.healthData.category.glycemia.2HoursAfterDinner',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_BEFORE_SLEEP,
										title: 'component.healthData.category.glycemia.beforeSleep',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_BEFORE_WORKOUT,
										title:
											'component.healthData.category.glycemia.beforeWorkout',
									},
									{
										type: MagicField.CHECKBOX,
										key: HealthData.BLOOD_GLUCOSE_3AM,
										title: 'component.healthData.category.glycemia.at3Am',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleBloodPressure',
		title: 'component.chart.filter.bloodPressureAndHearthBeat',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleWeight',
		title: 'component.chart.filter.weight',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleWaistline',
		title: 'component.chart.filter.waistline',
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'component.chart.filter.dataSource',
	},
	{
		type: MagicField.CONTAINER,
		key: 'source',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'appleHealth',
				title: 'component.chart.filter.appleHealth',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'googleFit',
				title: 'component.chart.filter.googleFit',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'bioScan',
				title: 'component.chart.filter.bioScan',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'questionnaire',
				title: 'component.chart.filter.questionnaires',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'ingestion',
				title: 'component.chart.filter.ingestion',
			},
		],
	},
];
